import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import AssociationDashboardPage from './pages/AssociationDashboardPage';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import CreateCertificatePage from './pages/CreateCertificatePage';
import CertificateDetailPage from './pages/CertificateDetailPage';
import ValidateCertificatePage from './pages/ValidateCertificatePage';
import VerifyCertificatePage from './pages/VerifyCertificatePage';
import ProfilePage from './pages/ProfilePage';
import ContactPage from './pages/ContactPage';
import CGUPage from './pages/CGUPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import CookieConsent from './components/CookieConsent';
import { AuthProvider, useAuth } from './contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Chargement...</div>;
  }
  
  return user ? children : <Navigate to="/login" />;
};

const DashboardRouter = () => {
  const { user } = useAuth();
  
  // Super admin gets special dashboard
  if (user?.role === 'super_admin') {
    return <SuperAdminDashboard />;
  }
  
  // Association admins get their enhanced dashboard
  if (user?.role === 'association_admin') {
    return <AssociationDashboardPage />;
  }
  
  // Regular volunteers get the standard dashboard
  return <DashboardPage />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardRouter />
            </ProtectedRoute>
          } />
          <Route path="/create-certificate" element={
            <ProtectedRoute>
              <CreateCertificatePage />
            </ProtectedRoute>
          } />
          <Route path="/certificate/:id" element={
            <ProtectedRoute>
              <CertificateDetailPage />
            </ProtectedRoute>
          } />
          <Route path="/validate/:validationLink" element={<ValidateCertificatePage />} />
          <Route path="/verify/:certificateId" element={<VerifyCertificatePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/cgu" element={<CGUPage />} />
          <Route path="/confidentialite" element={<PrivacyPolicyPage />} />
          <Route path="/profile" element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          } />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;